<ul class="extra-info">
  <li>
    <div class="my-account">
      <div class="extra-title">
        <h5>My Account</h5>
      </div>
      <ul>
        <li><a routerLink="/login" *ngIf="!tokenStorage.isLogin()">Login</a></li>
        <li><a (click)="logout()" *ngIf="tokenStorage.isLogin()">Logout</a></li>
        <li><a routerLink="/register" *ngIf="!tokenStorage.isLogin()">Create Account</a></li>
        <li><a routerLink="/account" *ngIf="tokenStorage.isLogin()">Account</a></li>
      </ul>
    </div>
  </li>
</ul>
